import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../Common/Sidebar";
import Loader from "../Common/Loader";
import { Card } from "primereact/card";
import CommonValues from "../Common/utils";
import { Button } from "react-bootstrap";

export default function CompanyDirectoryLandingPage() {
  const [showWideSidebar, setShowWideSidebar] = useState(true);
  const [employees, setEmployees] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [offices, setOffices] = useState([]);
  const [loading, setLoading] = useState(true);

  const onSidebarValueChanged = (value: any) => {
    setShowWideSidebar(value);
  };

  useEffect(() => {
    const token = CommonValues.GetToken();
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const fetchEmployees = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/employee/get`,
          { headers }
        );
        const data = Array.isArray(response.data)
          ? response.data
          : response.data?.data || response.data?.employees || [];
        setEmployees(data);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    const fetchDepartments = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/department/get`,
          { headers }
        );
        const data = Array.isArray(response.data)
          ? response.data
          : response.data?.data || response.data?.departments || [];
        setDepartments(data);
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };

    const fetchOffices = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/office/get`,
          { headers }
        );
        const data = Array.isArray(response.data)
          ? response.data
          : response.data?.data || response.data?.offices || [];
        setOffices(data);
      } catch (error) {
        console.error("Error fetching offices:", error);
      }
    };

    const fetchAllData = async () => {
      setLoading(true);
      await fetchEmployees();
      await fetchDepartments();
      await fetchOffices();
      setLoading(false);
    };

    fetchAllData();
  }, []);

  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar
        pagename="companydirectory"
        onSidebarValueChanged={onSidebarValueChanged}
      />

      <div className="flex-grow-1 d-flex flex-column bg-light p-2 mt-4">
        <div
          className={`${
            showWideSidebar
              ? "main-content-large-width"
              : "main-content-small-width"
          }`}
        >
          <>
            <div>
              <h2 className="fw-bold">Welcome to Company Directory</h2>
              <p className="text-muted">
                Your central hub for employee information and company structure
              </p>
            </div>

            <div className="card p-3">
              {loading ? (
              <div className="d-flex justify-content-center">
                             <Loader />
                           </div>
              ) : (
                <>
                  <div className="d-flex mt-4 mb-4 gap-4 dashboard-container">
                    <div className="info-block dashboard-card shadow-hover p-3 rounded-4 w-100 d-flex align-items-center justify-content-between">
                      <div>
                        <p className="dashboard-label mb-1">Total Employees</p>
                        <h2 className="dashboard-number mb-1">
                          {Array.isArray(employees) ? employees.length : 0}
                        </h2>
                        <p className="text-muted text-12 mb-0">
                          +12 this month
                        </p>
                      </div>
                      <i className="pi pi-users text-primary fs-1" />
                    </div>

                    <div className="info-block dashboard-card shadow-hover p-3 rounded-4 w-100 d-flex align-items-center justify-content-between">
                      <div>
                        <p className="dashboard-label mb-1">Departments</p>
                        <h2 className="dashboard-number mb-1">
                          {Array.isArray(departments) ? departments.length : 0}
                        </h2>
                        <p className="text-muted text-12 mb-0">
                          Active departments
                        </p>
                      </div>
                      <i className="pi pi-building text-success fs-1" />
                    </div>

                    <div className="info-block dashboard-card shadow-hover p-3 rounded-4 w-100 d-flex align-items-center justify-content-between">
                      <div>
                        <p className="dashboard-label mb-1">Office Locations</p>
                        <h2 className="dashboard-number mb-1">
                          {Array.isArray(offices) ? offices.length : 0}
                        </h2>
                        <p className="text-muted text-12 mb-0">
                          Global presence
                        </p>
                      </div>
                      <i className="pi pi-map-marker text-danger fs-1" />
                    </div>
                  </div>

                  <h6 className="fw-bold mb-3">Quick Actions</h6>
                  <div className="d-flex mt-3 mb-4 gap-4 dashboard-container">
                    <Card className="quick-action-card p-4 shadow-sm border-0 flex-grow-1 text-dark">
                      <div className="d-flex align-items-center gap-3">
                        <i className="pi pi-users text-primary fs-3" />
                        <div>
                          <p className="dashboard-label mb-1 fw-semibold">
                            Browse All Employees
                          </p>
                          <p className="text-muted small mb-0">
                            View the complete employee directory
                          </p>
                        </div>
                      </div>
                    </Card>

                    <Card className="quick-action-card p-4 shadow-sm border-0 flex-grow-1 text-dark">
                      <div className="d-flex align-items-center gap-3">
                        <i className="pi pi-sitemap text-success fs-3" />
                        <div>
                          <p className="dashboard-label mb-1 fw-semibold">
                            Explore Departments
                          </p>
                          <p className="text-muted small mb-0">
                            See all departments and teams
                          </p>
                        </div>
                      </div>
                    </Card>

                    <Card className="quick-action-card p-4 shadow-sm border-0 flex-grow-1 text-dark">
                      <div className="d-flex align-items-center gap-3">
                        <i className="pi pi-map-marker text-danger fs-3" />
                        <div>
                          <p className="dashboard-label mb-1 fw-semibold">
                            Office Locations
                          </p>
                          <p className="text-muted small mb-0">
                            Find office addresses and contacts
                          </p>
                        </div>
                      </div>
                    </Card>
                  </div>
                </>
              )}
            </div>
          </>
        </div>
      </div>
    </div>
  );
}
